import { render } from "./CompaniesHouseInfoComponent.vue?vue&type=template&id=bfa90fdc&scoped=true"
import script from "./CompaniesHouseInfoComponent.vue?vue&type=script&lang=js"
export * from "./CompaniesHouseInfoComponent.vue?vue&type=script&lang=js"

import "./CompaniesHouseInfoComponent.vue?vue&type=style&index=0&id=bfa90fdc&scoped=true&lang=css"

import exportComponent from "/tmp/build_1a3e5399/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bfa90fdc"]])

export default __exports__